<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }}
      </div>
      <router-link class="btn-blue" to="cinema-loyalty-settings"
        >{{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }}
        {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="new-border back rounded-10 p-3 mb-4">
        <div class="row">

          <div class="d-flex flex-wrap w-100 back_white mx-2 py-2 mb-3">
         
          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedcinema && selectedcinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="buttondisable"
                :text="selectedcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemaList"
                  :key="cinemaIndex"
                  @click.prevent.stop="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedcinema && selectedcinema.length == 0"
              class="error_message"
            >
              <span>{{ $t('pleaseSelectCinema') }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  globalloyaltyname && globalloyaltyname.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $t("global") }}
                {{ $t("loyaltysettings") }}</label
              >
              <b-dropdown
                :text="globalloyaltyname"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(globallist,
                  globallistIndex) in globalloyaltysettingsList"
                  :key="globallistIndex"
                  @click.prevent.stop="
                    onSelectGlobalLoyaltySettings(globallist)
                  "
                  >{{ globallist.ls_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p
              v-if="
                submitted && globalloyaltyname && globalloyaltyname.length == 0
              "
              class="error_message"
            >
              <span>{{ $t('please') }} {{ $t('select') }} Global {{ $t('loyaltysettings') }}</span>
            </p>
          </div>


<div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("canavailonline") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_online"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatboxoffice") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_bo"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatconcession") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_fnb"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </div>
              </div>


          
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4 mt-2" v-if="false">
            <div class="row mx-0">
              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("canavailonline") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_online"
                    unchecked-value="N"
                    value="Y"
                    switch
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatboxoffice") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_bo"
                    unchecked-value="N"
                    value="Y"
                    switch
                  ></b-form-checkbox>
                </div>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <div class="mr-3">{{ $t("availatconcession") }}</div>
                  <b-form-checkbox
                    v-model="cinema_loyalty_settings.redemption_fnb"
                    unchecked-value="N"
                    value="Y"
                    switch
                  ></b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          

          <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>3.&nbsp;</strong> -->
              {{ $t("minimumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.minimum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumpointearning"
                  id="minimumpointearning"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumpointearning')"
                class="error_message"
              >
                <span>{{ errors.first("minimumpointearning") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>4.&nbsp;</strong> -->
              {{ $t("maximumpointsearnings") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.maximum_points_earning"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumpointearning"
                  id="maximumpointearning"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumpointearning')"
              class="error_message"
            >
              <span>{{ errors.first("maximumpointearning") }}</span>
            </p>
          </div>

           <div class="col-lg-6 col-xl-3 mb-2">
            <div class="row mx-0 align-items-center">
              <!-- <strong>1.&nbsp;</strong> -->
              {{ $t("minimumpointsforredemption") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.minimum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="minimumreedempoints"
                  id="minimumreedempoints"
                />
              </div>
              <p
                v-if="submitted && errors.has('minimumreedempoints')"
                class="error_message"
              >
                <span>{{ errors.first("minimumreedempoints") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-8 mb-4">
            <div class="row mx-0 align-items-center">
              <!-- <strong>2.&nbsp;</strong> -->
              {{ $t("maximumpointstoberedeemedpertransaction") }} :
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.maximum_points_redemption"
                  v-validate="'required|numeric'"
                  placeholder="."
                  type="number"
                  name="maximumreedempoints"
                  id="maximumreedempoints"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('maximumreedempoints')"
              class="error_message"
            >
              <span>{{ errors.first("maximumreedempoints") }}</span>
            </p>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4 mt-2" v-if="false">
            <div class="row mx-0">
              <strong>5.&nbsp;</strong>
              {{ $t("requirementtoenroll") }}
              <b-form-checkbox
                v-model="cinema_loyalty_settings.email_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("email") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.mobile_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("mobiles") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.age_proof_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>{{ $t("age") }} {{ $t("proof") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.id_proof_is_required"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-3"
              >
                <div>Id {{ $t("proof") }}</div>
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 mb-4">
            <div class="d-flex">
              <!-- <strong>6.&nbsp;</strong> -->
              <div class="input-material-textarea">
                <textarea
                  v-model="cinema_loyalty_settings.eligibility_to_enroll"
                  rows="2"
                  v-validate="'required'"
                  type="text"
                  name="eligibilitytoenroll"
                  id="eligibilitytoenroll"
                  class="rounded-10"
                ></textarea>
                <label>{{ $t("eligibilitytoenroll") }}</label>
              </div>
            </div>
            <p
              v-if="submitted && errors.has('eligibilitytoenroll')"
              class="error_message"
            >
              <span>{{ errors.first("eligibilitytoenroll") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <!-- <strong>7.&nbsp;</strong> -->
                {{ $t("earnpointsondicount") }}
              </div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.earn_points_on_discount"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <!-- <strong>8.&nbsp;</strong> -->
                {{ $t("burnpointsondicount") }}
              </div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.burn_points_on_discount"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="h6 w-100 px-3">{{ $t("earnpoints") }}</div>
          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.earn_ratio_bo"
                  v-validate="'required|numeric'"
                  type="number"
                  name="earnboxofficeratio"
                  id="earnboxofficeratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('earnboxofficeratio')"
                class="error_message"
              >
                <span>{{ errors.first("earnboxofficeratio") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $tc("fb", 1) }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.earn_ratio_fnb"
                  v-validate="'required|numeric'"
                  type="number"
                  name="earnfnbratio"
                  id="earnfnbratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('earnfnbratio')"
                class="error_message"
              >
                <span>{{ errors.first("earnfnbratio") }}</span>
              </p>
            </div>
          </div>

          <div class="h6 w-100 px-3">{{ $t("burnpoints") }}</div>

          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.burn_ratio_bo"
                  v-validate="'required|numeric'"
                  type="number"
                  name="burnboxofficeratio"
                  id="burnboxofficeratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('burnboxofficeratio')"
                class="error_message"
              >
                <span>{{ errors.first("burnboxofficeratio") }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $tc("fb", 1) }} {{ $t("ratio") }} :</span>
              <div class="input-material-sm mx-2">
                <input
                  v-model="cinema_loyalty_settings.burn_ratio_fnb"
                  v-validate="'required|numeric'"
                  type="number"
                  name="burnfnbratio"
                  id="burnfnbratio"
                />
              </div>
              <p
                v-if="submitted && errors.has('burnfnbratio')"
                class="error_message"
              >
                <span>{{ errors.first("burnfnbratio") }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <div class="row">
          <div class="col-md-3 col-xl-2">
            <label>{{ $t("active") }}</label>
          </div>
          <div class="col-md-9 col-xl-10">
            <div>
              <b-form-checkbox
                v-model="cinema_loyalty_settings.cls_is_active"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="cinema-loyalty-settings"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      buttondisable: true,
      btenable: false,
      submitted: false,
      cinemaList: [],
      globalloyaltysettingsList: [],
      globalloyaltyname: "",
      selectedcinema: "",
      cinema_loyalty_settings: {
        cls_id: null,
        cinema_id: null,
        ls_id: null,
        redemption_online: "Y",
        redemption_bo: "Y",
        redemption_fnb: "Y",
        minimum_points_redemption: "",
        maximum_points_redemption: "",
        minimum_points_earning: "",
        maximum_points_earning: "",
        email_is_required: "Y",
        mobile_is_required: "N",
        age_proof_is_required: "N",
        id_proof_is_required: "N",
        eligibility_to_enroll: "",
        earn_ratio_bo: "",
        earn_ratio_fnb: "",
        burn_ratio_bo: "",
        burn_ratio_fnb: "",
        earn_points_on_discount: "Y",
        burn_points_on_discount: "N",
        cls_is_active: "Y"
      }
    };
  },
  beforeMount() {
    const { cls_id } = this.$route.query;
    // this.getCinemaList();
    this.getGlobalLoyaltySettingsList();
    this.getCinemaLoyaltySettingsBYID(cls_id);
  },
  methods: {
    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({
        activekey: "cine_is_active",
        conditionColName: "cine_id",
        conditionId: cine_id
      })

        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.cinemaList = data.Records;
              if (cine_id === undefined) {
              } else {
                this.cinemaList.map(x => {
                  if (cine_id == x.cine_id) {
                    this.cinema_loyalty_settings.cinema_id = x.cine_id;
                    this.selectedcinema = x.cine_name;
                  }
                });
              }
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          }
        })
        .catch(this._CatchError);
    },
    getGlobalLoyaltySettingsList: function(ls_id) {
      MarketingService.GetActiveGlobalLoyaltySettings({
        activekey: "ls_is_active"
      })

        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.globalloyaltysettingsList = data.Records;
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          }
        })
        .catch(this._CatchError);
    },

    getCinemaLoyaltySettingsBYID: function(id) {
      let payload = {
        cls_id: id
      };
      MarketingService.GetCinemaLoyaltySettingsBYID(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];

            this.cinema_loyalty_settings.cls_id = obj.cls_id;
            this.getCinemaList(obj.cinema_id);
            this.globalloyaltyname = obj.ls_name;
            this.cinema_loyalty_settings.ls_id = obj.ls_id;
            this.cinema_loyalty_settings.redemption_online =
              obj.redemption_online;
            this.cinema_loyalty_settings.redemption_bo = obj.redemption_bo;
            this.cinema_loyalty_settings.redemption_fnb = obj.redemption_fnb;
            this.cinema_loyalty_settings.minimum_points_redemption =
              obj.minimum_points_redemption;
            this.cinema_loyalty_settings.maximum_points_redemption =
              obj.maximum_points_redemption;
            this.cinema_loyalty_settings.minimum_points_earning =
              obj.minimum_points_earning;
            this.cinema_loyalty_settings.maximum_points_earning =
              obj.maximum_points_earning;
            this.cinema_loyalty_settings.email_is_required =
              obj.email_is_required;
            this.cinema_loyalty_settings.mobile_is_required =
              obj.mobile_is_required;
            this.cinema_loyalty_settings.age_proof_is_required =
              obj.age_proof_is_required;
            this.cinema_loyalty_settings.id_proof_is_required =
              obj.id_proof_is_required;
            this.cinema_loyalty_settings.eligibility_to_enroll =
              obj.eligibility_to_enroll;
            this.cinema_loyalty_settings.earn_ratio_bo = obj.earn_ratio_bo;
            this.cinema_loyalty_settings.earn_ratio_fnb = obj.earn_ratio_fnb;
            this.cinema_loyalty_settings.burn_ratio_bo = obj.burn_ratio_bo;
            this.cinema_loyalty_settings.burn_ratio_fnb = obj.burn_ratio_fnb;
            this.cinema_loyalty_settings.earn_points_on_discount =
              obj.earn_points_on_discount;
            this.cinema_loyalty_settings.burn_points_on_discount =
              obj.burn_points_on_discount;
            this.cinema_loyalty_settings.cls_is_active = obj.cls_is_active;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(params) {
      this.cinema_loyalty_settings.cinema_id = params.cine_id;
      this.selectedcinema = params.cine_name;
    },

    onSelectGlobalLoyaltySettings(params) {
      this.cinema_loyalty_settings.ls_id = params.ls_id;
      this.globalloyaltyname = params.ls_name;
    },
    addLoyaltySettings: function() {
      this.loyalty_levels.push({
        ll_name: ""
      });
    },
    removeLoyaltySettings: function(index) {
      this.loyalty_levels.splice(index, 1);
    },

    OnFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (
          this.cinema_loyalty_settings.cinema_id &&
          this.cinema_loyalty_settings.cinema_id.length == 0
        ) {
          return;
        } else if (
          this.globalloyaltyname &&
          this.globalloyaltyname.length == 0
        ) {
          return;
        } else if (this.selectedcinema && this.selectedcinema.length == 0) {
          return;
        }
        if (valid) {
          this.btenable = true;

          let payload = {
            cls: this.cinema_loyalty_settings
          };

          MarketingService.UpdateCinemaLoyaltySettingsBYID(payload)
            .then(response => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.submitted = false;
                this.$router.push({
                  path: "/marketing/cinema-loyalty-settings"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltySettingsComponents/editcinemaloyaltysettings.vue